module.exports = __webpack_public_path__ + "static/media/registerLockGuide3_Jap.111786fe.png";